var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "193 93 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359 195.386V102.855C359 100.726 357.311 99 355.182 99H262.614C241.41 99 229.797 119.284 199 152.976H291.53C301.169 152.976 308.88 149.12 316.59 141.41C308.88 149.12 305.024 156.831 305.024 166.47V259C337.288 229.617 359 216.59 359 195.386Z",
    fill: "url(#paint0_radial_360_45011)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.205 130.956L319.054 130.41L317.967 126.723L315.662 129.8C306.339 142.252 293.555 144.635 280.019 146.307C278.998 146.433 277.969 146.555 276.937 146.677C264.524 148.15 251.529 149.691 241.879 159.553C223.398 178.438 228.316 202.086 228.422 202.577L229.568 207.868L232.024 203.043C232.046 202.999 232.096 202.876 232.173 202.682C233.435 199.524 242.197 177.593 265.041 173.281L265.041 173.281C276.941 171.034 285.74 168.138 292.13 165.35C287.571 168.099 282.678 169.691 277.473 171.309C277.177 171.401 276.88 171.493 276.582 171.586C266.623 174.674 255.634 178.081 244.898 190.164L244.898 190.164C235.859 200.338 231.433 209.536 229.342 217.309C227.252 225.075 227.524 231.316 227.729 235.44C227.839 237.657 229.723 239.363 231.939 239.258L231.942 239.258C234.046 239.154 235.718 237.451 235.771 235.341L235.772 235.341C235.829 233.083 236.22 228.908 238.046 224.179C240.051 218.991 244.915 215.446 250.463 215.139L250.463 215.139C252.491 215.027 254.622 214.96 256.833 214.89C271.793 214.416 290.427 213.826 305.432 198.493C318.469 185.17 321.82 168.049 321.972 154.451C322.049 147.636 321.324 141.647 320.58 137.361C320.208 135.215 319.831 133.492 319.545 132.298C319.401 131.701 319.281 131.236 319.195 130.917C319.152 130.758 319.118 130.635 319.094 130.55C319.082 130.507 319.073 130.474 319.066 130.451L319.058 130.423L319.056 130.415L319.055 130.412C319.055 130.411 319.054 130.41 317.205 130.956Z",
    fill: "#45C1C5",
    stroke: "white",
    strokeWidth: 3.85542
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_360_45011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.53 17.0723) rotate(139.277) scale(246.726 191.94)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F396C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.e2f01090eccfd9ced7f256071348a38c.svg";
export { ForwardRef as ReactComponent };